import React from "react";
import "./Projects.css"

const ProjectChoice = ({ onSelect }) => {

    return (
        <div className="projects-screen">

            <div className="projects-header">

                <h1>
                    Projects
                </h1>

                <p>
                    Start a new project or continue
                    working on an existing project.
                </p>

            </div>


            <div className="project-choice-grid">

                <button
                    type="button"
                    className="project-choice-card"
                    onClick={() => onSelect("new")}
                >

                    <div className="project-choice-icon">
                        +
                    </div>

                    <div className="project-choice-content">

                        <h2>
                            New Project
                        </h2>

                        <p>
                            Create a new space robotics
                            project.
                        </p>

                    </div>

                    <div className="project-choice-arrow">
                        →
                    </div>

                </button>


                <button
                    type="button"
                    className="project-choice-card"
                    onClick={() => onSelect("open")}
                >

                    <div className="project-choice-icon">
                        ▣
                    </div>

                    <div className="project-choice-content">

                        <h2>
                            Open Project
                        </h2>

                        <p>
                            Continue working on an
                            existing project.
                        </p>

                    </div>

                    <div className="project-choice-arrow">
                        →
                    </div>

                </button>

            </div>

        </div>
    );
};

export default ProjectChoice;